import { Form, InputNumber } from 'antd';
import React from 'react';
import DrawerButtons from '../../drawer-buttons';
import { translations } from '../../../config/translations';
import { showError, showSuccess } from '../../../helpers/NotificationHelper';
import {
    WorkHourRecordsClient,
    ApiException,
    UpdateAllProjectsWorkHourDeadlineCommand,
} from '../../../utils/api';

interface Props {
    onClose: () => void;
    onSuccess: () => void;
    initialValue: number;
}

interface State {
    isSaving: boolean;
}

class WorkHourDeadlineForm extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);

        this.state = {
            isSaving: false,
        };
    }

    private handleSubmit = async (values: any) => {
        this.setState({
            isSaving: true,
        });

        try {
            await new WorkHourRecordsClient().updateAllProjectsWorkHourDeadline(
                UpdateAllProjectsWorkHourDeadlineCommand.fromJS({
                    workHourEntryDeadlineExtensionInDays: values.workHourDeadlineExtension,
                })
            );

            showSuccess(translations.workHourRecods.workHourDeadlineExtensionSuccess);

            this.props.onSuccess();
        } catch (error) {
            if (error instanceof ApiException) {
                showError(error.response);
            } else {
                showError(translations.general.errorSavingData);
            }
        }

        this.setState({
            isSaving: false,
        });
    };

    public render(): React.ReactElement {
        const { onClose, initialValue } = this.props;
        const { isSaving } = this.state;

        return (
            <Form
                onFinish={this.handleSubmit}
                style={{ textAlign: 'end' }}
                initialValues={{ workHourDeadlineExtension: initialValue }}
            >
                <DrawerButtons isSaving={isSaving} onCancelAction={onClose} />

                <Form.Item
                    name="workHourDeadlineExtension"
                    label={translations.workHourRecods.workHourDeadlineExtensionLabel}
                    rules={[
                        {
                            required: true,
                            message: translations.general.requiredField,
                        },
                        {
                            type: 'number',
                            min: 0,
                            max: 30,
                            message:
                                translations.workHourRecods.workHourDeadlineExtensionValidation,
                        },
                    ]}
                >
                    <InputNumber
                        min={0}
                        max={30}
                        style={{ width: '100%' }}
                        placeholder={
                            translations.workHourRecods.workHourDeadlineExtensionPlaceholder
                        }
                    />
                </Form.Item>
            </Form>
        );
    }
}

export default WorkHourDeadlineForm;
